/* ØRIGEN Landing System · Comportamiento (carga solo en landings) */
(function(){
  "use strict";

  /* ---------- Reveal on scroll ---------- */
  function reveal(root){
    if(!('IntersectionObserver' in window)){
      (root||document).querySelectorAll('.ol-rv').forEach(function(el){el.classList.add('ol-vis');});
      return;
    }
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('ol-vis'); io.unobserve(e.target); } });
    },{threshold:.12});
    (root||document).querySelectorAll('.ol-rv:not(.ol-vis)').forEach(function(el){io.observe(el);});
  }

  /* ---------- Tabs (timeline / ingredientes) ---------- */
  function initTabset(set){
    if(set.dataset.olInit) return; set.dataset.olInit='1';
    var tabs=set.querySelectorAll('.ol-tab');
    var panels=set.querySelectorAll('.ol-panel');
    var fill=set.querySelector('.ol-fill');
    var n=tabs.length; if(!n) return;
    function go(k){
      tabs.forEach(function(t,x){t.classList.toggle('on',x===k);});
      panels.forEach(function(p,x){p.classList.toggle('on',x===k);});
      if(fill) fill.style.width=((k+1)/n*100)+'%';
    }
    tabs.forEach(function(t,x){t.addEventListener('click',function(){go(x);});});
  }

  /* ---------- Carrusel (videos / reseñas) ---------- */
  function initCarrusel(car){
    if(car.dataset.olInit) return; car.dataset.olInit='1';
    var track=car.querySelector('.ol-track');
    var slides=car.querySelectorAll('.ol-slide');
    var dots=car.querySelectorAll('.ol-dot');
    var n=slides.length; if(!n||!track) return;
    var i=0;
    function go(k){ i=(k+n)%n; track.style.transform='translateX(-'+(i*100)+'%)'; dots.forEach(function(d,x){d.classList.toggle('on',x===i);}); }
    car.querySelectorAll('.ol-flecha').forEach(function(f){ f.addEventListener('click',function(){ go(i+parseInt(f.getAttribute('data-dir'),10)); }); });
    dots.forEach(function(d){ d.addEventListener('click',function(){ go(parseInt(d.getAttribute('data-i'),10)); }); });
    var x0=null,dx=0;
    track.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;dx=0;},{passive:true});
    track.addEventListener('touchmove',function(e){if(x0!==null)dx=e.touches[0].clientX-x0;},{passive:true});
    track.addEventListener('touchend',function(){ if(Math.abs(dx)>50) go(i+(dx<0?1:-1)); x0=null; });
    go(0);
  }

  /* ---------- Hero (galería, paquetes, contador, CTA) ---------- */
  function initHero(zona){
    if(zona.dataset.olInit) return; zona.dataset.olInit='1';
    var main = zona.querySelector('.ol-galeria-img');
    zona.querySelectorAll('.ol-mini').forEach(function(m){
      m.addEventListener('click',function(){
        var full=m.getAttribute('data-full'); if(main&&full){ if(main.tagName==='IMG'){main.src=full;main.removeAttribute('srcset');} }
        zona.querySelectorAll('.ol-mini').forEach(function(x){x.classList.remove('on');});
        m.classList.add('on');
      });
    });
    var paqs = zona.querySelectorAll('.ol-paq');
    paqs.forEach(function(p){ p.addEventListener('click',function(){ paqs.forEach(function(x){x.classList.remove('on');}); p.classList.add('on'); }); });

    var box = zona.querySelector('.ol-oferta-box');
    if(box){
      var mins=parseInt(box.getAttribute('data-oferta-min'),10)||55;
      var key='olOferta_'+box.getAttribute('data-oferta-id');
      var end;
      try{ end=parseInt(localStorage.getItem(key),10); }catch(e){}
      var now=Date.now();
      if(!end||end<now){ end=now+mins*60000; try{localStorage.setItem(key,end);}catch(e){} }
      var h=box.querySelector('[data-reloj=h]'),m=box.querySelector('[data-reloj=m]'),s=box.querySelector('[data-reloj=s]');
      function pad(x){return (x<10?'0':'')+x;}
      function tick(){
        var d=end-Date.now();
        if(d<=0){ end=Date.now()+mins*60000; try{localStorage.setItem(key,end);}catch(e){} d=end-Date.now(); }
        var t=Math.floor(d/1000), hh=Math.floor(t/3600), mm=Math.floor((t%3600)/60), ss=t%60;
        if(h)h.innerHTML=pad(hh)+'<small>hrs</small>'; if(m)m.innerHTML=pad(mm)+'<small>min</small>'; if(s)s.innerHTML=pad(ss)+'<small>seg</small>';
      }
      tick(); setInterval(tick,1000);
    }

  }

  /* ---------- CTA global (add_to_cart / enlace; EasySell lo maneja solo) ---------- */
  function initCta(btn){
    if(btn.dataset.olInit) return; btn.dataset.olInit='1';
    var accion=btn.getAttribute('data-accion');
    if(accion==='easysell'||btn.classList.contains('es-popup-button-overwrite')) return; // EasySell engancha el click
    btn.addEventListener('click',function(){
      var enlace=btn.getAttribute('data-enlace');
      if(accion==='enlace'){ if(enlace) window.location.href=enlace; return; }
      var sel=document.querySelector('.ol-paq.on')||document.querySelector('.ol-paq');
      var vid=btn.getAttribute('data-variante') || (sel?sel.getAttribute('data-variante'):'');
      if(vid){
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:vid,quantity:1})})
          .then(function(){ window.location.href='/checkout'; })
          .catch(function(){ window.location.href='/cart'; });
      } else if(enlace){ window.location.href=enlace; }
      else { var f=document.querySelector('form[action*="/cart/add"]'); if(f){ f.requestSubmit?f.requestSubmit():f.submit(); } }
    });
  }

  /* ---------- Barra fija (aparece al hacer scroll) ---------- */
  function initBarra(bar){
    if(bar.dataset.olInit) return; bar.dataset.olInit='1';
    var disparador=document.querySelector('.ol-cta')||document.querySelector('.ol-hero');
    function chk(){
      var show=true;
      if(disparador){ var r=disparador.getBoundingClientRect(); show = r.bottom < 0; }
      bar.classList.toggle('ol-visible',show);
    }
    window.addEventListener('scroll',chk,{passive:true}); chk();
    var btn=bar.querySelector('.ol-bf-btn');
    if(btn && !btn.classList.contains('es-popup-button-overwrite')){ btn.addEventListener('click',function(){
      var enlace=btn.getAttribute('data-enlace'); var cta=document.querySelector('.ol-cta');
      if(enlace){ window.location.href=enlace; }
      else if(cta){ cta.click(); }
    }); }
  }

  /* ---------- Sync paquete de la página → oferta de cantidad de EasySell ---------- */
  /* EasySell muestra su propio selector de cantidad dentro del popup y arranca en la 1ª oferta.
     Al abrir el popup, seleccionamos la oferta cuyo número de unidades coincide con el
     paquete elegido en la página. */
  function olEsCantidadSeleccionada(){
    var p=document.querySelector('.ol-paq.on')||document.querySelector('.ol-paq');
    if(!p) return null;
    // 1º: número dentro del nombre del paquete ("2 frascos" -> 2). Funciona sin configurar nada.
    var nom=(p.querySelector('.ol-paq-nom')||{}).textContent||'';
    var mm=nom.match(/\d+/);
    if(mm) return parseInt(mm[0],10);
    // 2º: campo "Cantidad" del bloque (para nombres sin número)
    var c=parseInt(p.getAttribute('data-cantidad'),10);
    return c>0?c:null;
  }
  function olEsElegirOferta(qty){
    var conts=document.querySelectorAll('.es-quantity-offers .es-qo-container');
    if(!conts.length) return false;
    for(var i=0;i<conts.length;i++){
      var t=conts[i].querySelector('.offer-title');
      if(!t) continue;
      var m=t.textContent.match(/\d+/);
      if(m && parseInt(m[0],10)===qty){ conts[i].click(); return true; }
    }
    return false;
  }
  function olEsAlAbrir(){
    var qty=olEsCantidadSeleccionada();
    if(!qty) return;
    var tries=0;
    var iv=setInterval(function(){
      tries++;
      if(olEsElegirOferta(qty)||tries>40){ clearInterval(iv); }
    },100);
  }
  function initEsSync(){
    if(document.documentElement.dataset.olEsSync) return;
    document.documentElement.dataset.olEsSync='1';
    document.addEventListener('click',function(e){
      var btn=e.target.closest('.es-popup-button-overwrite, .ol-cta[data-accion="easysell"], .ol-bf-btn');
      if(btn){ setTimeout(olEsAlAbrir,120); }
    },true);
  }

  /* ---------- Video: botón de play sobre el poster ---------- */
  function initVid(wrap){
    if(wrap.dataset.olInit) return; wrap.dataset.olInit='1';
    var vid=wrap.querySelector('.ol-vid');
    var btn=wrap.querySelector('.ol-vid-play');
    if(!vid) return;
    if(btn){ btn.addEventListener('click',function(){ vid.play(); }); }
    vid.addEventListener('play',function(){ wrap.classList.add('ol-playing'); });
    vid.addEventListener('pause',function(){ wrap.classList.remove('ol-playing'); });
    vid.addEventListener('ended',function(){ wrap.classList.remove('ol-playing'); });
  }

  /* ---------- Stats: conteo animado al hacerse visible ---------- */
  function animarNumero(el){
    if(el.dataset.olCount) return; el.dataset.olCount='1';
    var raw=(el.textContent||'').trim();
    var m=raw.match(/([0-9][0-9.,]*)/);
    if(!m){ return; }
    var numStr=m[1].replace(/\./g,'').replace(/,/g,'');
    var target=parseInt(numStr,10);
    if(!(target>0)){ return; }
    var pre=raw.slice(0,m.index);
    var post=raw.slice(m.index+m[1].length);
    function fmt(n){ return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g,'.'); }
    var dur=1100, t0=null;
    function step(ts){
      if(!t0) t0=ts;
      var p=Math.min((ts-t0)/dur,1);
      var eased=1-Math.pow(1-p,3);
      el.textContent=pre+fmt(Math.round(target*eased))+post;
      if(p<1) requestAnimationFrame(step);
      else el.textContent=raw;
    }
    requestAnimationFrame(step);
  }
  function initStats(zona){
    if(zona.dataset.olInit) return; zona.dataset.olInit='1';
    var nums=zona.querySelectorAll('.ol-stat-num, .ol-res-num');
    if(!nums.length) return;
    if(!('IntersectionObserver' in window)){ nums.forEach(animarNumero); return; }
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ animarNumero(e.target); io.unobserve(e.target); } });
    },{threshold:.5});
    nums.forEach(function(n){ io.observe(n); });
  }

  function run(root){
    var scope=root&&root.querySelectorAll?root:document;
    initEsSync();
    reveal(scope);
    (scope.querySelectorAll('.ol-tabset')||[]).forEach(initTabset);
    scope.querySelectorAll('.ol-carrusel').forEach(initCarrusel);
    scope.querySelectorAll('.ol-hero-zona').forEach(initHero);
    scope.querySelectorAll('.ol-cta').forEach(initCta);
    scope.querySelectorAll('.ol-barra-fija').forEach(initBarra);
    scope.querySelectorAll('.ol-vid-wrap').forEach(initVid);
    scope.querySelectorAll('.ol-stats-zona').forEach(initStats);
  }

  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',function(){run(document);}); }
  else { run(document); }
  document.addEventListener('shopify:section:load',function(e){ run(e.target); });
})();
